import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 查询电表单价
 * @param {Object} data
 * @returns
 */
export function listMeterPrice (data) {
  return request.post('/ooh-invest/electricMeterPrice/listMeterPrice', qs.stringify(data))
}
/**
 * 新增电表单价
 * @param {Object} data
 * @returns
 */
export function saveUnitPrice (params) {
  return request({
    url: '/ooh-invest/electricMeterPrice/saveUnitPrice',
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  })
}
/**
 * 修改电表单价
 * @param {Object} data
 * @returns
 */
export function updateUnitPrice (params) {
  return request({
    url: '/ooh-invest/electricMeterPrice/updateUnitPrice',
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  })
}
